import { createContext, useContext } from 'react'
import type { AISubscription } from '@/lib/ai'

export type PricingTab = 'plans' | 'credits'

export interface BillingContextValue {
    /** The plan the agent is on, `null` on none, `undefined` while loading. */
    subscription: AISubscription | null | undefined
    refreshSubscription: () => Promise<AISubscription | null>
    /** Goes to the pricing page, on its plans or its top-ups. */
    openPricing: (tab?: PricingTab) => void
    setSubscription: (subscription: AISubscription | null) => void
    /** Opens the Usage dialog. */
    openUsage: () => void
    /** Changes whenever the balance should be loaded again. */
    balanceVersion: number
    /** Asks everything showing the balance to load it again. */
    refreshBalance: () => void
}

export const BillingContext = createContext<BillingContextValue | null>(null)

export const useBilling = () => {
    const value = useContext(BillingContext)
    if (!value) throw new Error('useBilling must be used inside BillingProvider')
    return value
}
